import * as React from 'react';

import { ClickTracker } from 'bernie-analytics';

import { UitkPill, UitkPillProps, UitkRemovablePill, UitkRemovablePillProps } from 'uitk-react-pill';

import { DoubleLink } from 'components/common/media/double-link';

const LinkTracked = ClickTracker(DoubleLink);

export interface Pill {
  pillLabel: string;
  type: string;
  value?: string;
  state?: string;
  query?: string;
}

export interface PillProps {
  model: Pill;
  pillType: 'pill' | 'removablePill';
  pillProps: UitkPillProps | UitkRemovablePillProps;
  referrerId?: string;
  replace: boolean;
}

export enum PillStates {
  SELECTED = 'SELECTED',
  UNSELECTED = 'UNSELECTED'
}

export const LodgingPill: React.FunctionComponent<PillProps> = props => {
  const { model, pillType, pillProps, referrerId, replace } = props;

  if (!model) {
    return null;
  }

  switch (pillType) {
    case 'removablePill':
      return <RemovablePill {...{ model, referrerId, replace, ...(pillProps as UitkRemovablePillProps) }} />;
    default:
      return <DefaultPill {...{ model, ...(pillProps as UitkPillProps) }} />;
  }
};

export interface DefaultPillProps extends UitkPillProps {
  model: Pill;
}

export const DefaultPill: React.FunctionComponent<DefaultPillProps> = props => {
  const { model, ...rest } = props;
  const { pillLabel, value } = model;

  return (
    <UitkPill {...rest} active={value === PillStates.SELECTED}>
      {pillLabel}
    </UitkPill>
  );
};

export interface RemovablePillProps extends UitkRemovablePillProps {
  model: Pill;
  referrerId?: string;
  replace: boolean;
}

export const RemovablePill: React.FunctionComponent<RemovablePillProps> = props => {
  const { model, referrerId, replace, ...rest } = props;
  const { pillLabel, query } = model;

  const child = <UitkRemovablePill {...rest}>{pillLabel}</UitkRemovablePill>;

  if (query) {
    return (
      <LinkTracked className="pill-link" rfrr={referrerId} to={`${query}`} replace={replace}>
        {child}
      </LinkTracked>
    );
  }

  return child;
};
